/* eslint-disable max-len */
import React, { useEffect, useState } from "react";
import "./FilterData.scss";
import { ArrowDown, ArrowUp } from "react-feather";
import InputSelect from "components/atoms/InputSelect";
import InputRadio from "components/atoms/InputRadio";
import Button from "components/atoms/Button";
import InputDate from "components/atoms/InputDate";
import moment from "moment";
import Wilayah from "services/Wilayah";
import Analysis from "services/Analysis";
import Fasyankes from "services/Fasyankes";
import { Source, UserLevel, indicatorAnalysisOptions } from "utils/constant";
import BKK from "services/BKK";
import { getCurrentUserFromLocalStorage, monthConverter } from "utils/common";
import Chart from "./Chart";
import JentikTrendChart from "./JentikTrendChart";
import JentikTrendTable from "./JentikTrendTable";
import { weeklyRangeToIso } from "./chartLabels";
import { HashLoader } from "react-spinners";
import MyMap from "./Map";
import { toast } from "react-toastify";

const WilayahService = new Wilayah();
const FasyankesService = new Fasyankes();
const BKKService = new BKK();
const AnalysisService = new Analysis();

const initialPeriodDate = {
  year: null,
  month: null,
  week: null,
  startDate: null,
  endDate: null,
};

const initialDate = {
  year: "",
  month: "",
  week: "",
  dateFrom: "",
  dateTo: "",
};

const initialDomicile = {
  provincies: [],
  districts: [],
  fasyankes: [],
};

const FilterDataComponent = () => {
  const currentUser = getCurrentUserFromLocalStorage();

  const initialDomicileSelected = {
    provincies: currentUser?.province_id,
    districts: currentUser?.district_id,
    fasyankes: currentUser?.fasyankes_id,
  };

  let currentUserLevel = currentUser.level;
  if (currentUserLevel == UserLevel.SR) {
    currentUserLevel = UserLevel.Province;
  } else if (currentUserLevel == UserLevel.SSR) {
    currentUserLevel = UserLevel.District;
  } else if (currentUserLevel == UserLevel.BKKInduk) {
    currentUserLevel = UserLevel.BKKInduk;
  } else if (currentUserLevel == UserLevel.BKKWilker) {
    currentUserLevel = UserLevel.BKKWilker;
  }

  // BKK users (induk/wilker) may only select these 9 indicators.
  const bkkIndicatorValues = [
    "indikator_1",
    "indikator_2",
    "indikator_4",
    "indikator_7",
    "indikator_8",
    "indikator_9",
    "indikator_10",
    "indikator_11",
    "indikator_20",
  ];
  const isBkkUser =
    currentUser.level === UserLevel.BKKInduk ||
    currentUser.level === UserLevel.BKKWilker;
  const indikatorOptions = isBkkUser
    ? indicatorAnalysisOptions.filter((o) =>
      bkkIndicatorValues.includes(o.value)
    )
    : indicatorAnalysisOptions;

  const [chartData, setChartData] = useState([]);
  const [isLoading, setLoading] = useState(false);

  // Applied values for Chart — only update when "Terapkan" is clicked
  const [appliedPeriod, setAppliedPeriod] = useState("");
  const [appliedLevel, setAppliedLevel] = useState("");

  const [showFilter, setShowFilter] = useState(true);
  const [showChart, setShowChart] = useState(false);
  const [dateString, setDateString] = useState("");
  const [date, setDate] = useState(initialDate);
  const [domicile, setDomicile] = useState(initialDomicile);
  const [domicileSelected, setDomicileSelected] = useState(
    initialDomicileSelected
  );
  const [selectPeriode, setSelectPeriode] = useState("");
  const [selectLevel, setSelectedLevel] = useState(currentUserLevel);
  const [levelData, setLevelData] = useState([]);
  const [selectedIndikator, setSelectedIndikator] = useState("");

  const [periodDate, setPeriodDate] = useState(initialPeriodDate);
  const [currentDomicileSelected, setCurrentDomicileSelected] = useState({});
  const [currentDomicile, setCurrentDomicile] = useState("");

  const [levelIdSelected, setLevelIdSelected] = useState("Indonesia");
  const [selectedInduk, setSelectedInduk] = useState("");
  const [selectedWilker, setSelectedWilker] = useState("");
  const [levelDataOptions, setLevelDataOptions] = useState({
    induks: [],
    wilkers: [],
  });

  // total denum proposi plasmodium
  const [totalData, setTotalData] = useState(0);

  // selected wilayah
  const getWeekNumber = (date) => {
    const d = new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    );
    const dayNum = d.getUTCDay() || 7;
    d.setUTCDate(d.getUTCDate() + 4 - dayNum);
    const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    return Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  };

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${day}-${month}-${year}`;
  };

  const generateWeeks = (year) => {
    const weeks = [];
    const startDate = new Date(year, 0, 1);
    const endDate = new Date(year, 11, 31);
    const currentDate = new Date(startDate);

    while (currentDate <= endDate) {
      const weekStartDate = new Date(currentDate);
      const weekEndDate = new Date(currentDate);
      weekEndDate.setDate(currentDate.getDate() + 6);

      const weekLabel = `Minggu ${getWeekNumber(currentDate)}`;
      const weekRange = `${formatDate(weekStartDate)} - ${formatDate(
        weekEndDate
      )}`;

      weeks.push({ label: weekLabel, value: weekRange });

      currentDate.setDate(currentDate.getDate() + 7);
    }

    return weeks;
  };

  const renderPeriodeFilter = () => {
    if (selectPeriode === "Tahunan") {
      if (
        selectedIndikator === "indikator_3" ||
        selectedIndikator === "indikator_16" ||
        selectedIndikator === "indikator_25" ||
        selectedIndikator === "indikator_6"
      ) {
        return (
          <div className="filter-condition" key={selectPeriode}>
            <InputDate
              label={"Dari"}
              placeholder={"Pilih Tahun"}
              dateFormat={"YYYY"}
              onChange={(e) => {
                setDate({
                  ...date,
                  year: moment(e).format("YYYY"),
                  dateFrom: moment(e).format("YYYY-MM-DD"),
                });
                setPeriodDate({ ...periodDate, year: e, startDate: e });
              }}
              value={periodDate.startDate}
            />
            <InputDate
              label={"Sampai"}
              placeholder={"Pilih Tahun"}
              dateFormat={"YYYY"}
              onChange={(e) => {
                setDate({
                  ...date,
                  year: moment(e).format("YYYY"),
                  dateTo: moment(e).format("YYYY-MM-DD"),
                });
                setPeriodDate({ ...periodDate, year: e, endDate: e });
              }}
              value={periodDate.endDate}
            />
          </div>
        );
      }
      return (
        <div className="filter-condition" key={selectPeriode}>
          <InputDate
            placeholder={"Pilih Tahun"}
            dateFormat={"YYYY"}
            onChange={(e) => {
              setDate({ ...date, year: moment(e).format("YYYY") });
              setPeriodDate({ year: e });
            }}
            value={periodDate.year}
          />
        </div>
      );
    } else if (selectPeriode === "Bulanan") {
      if (
        selectedIndikator === "indikator_1" ||
        selectedIndikator === "indikator_2" ||
        selectedIndikator === "indikator_30" ||
        selectedIndikator === "indikator_20" ||
        selectedIndikator === "indikator_7" ||
        selectedIndikator === "indikator_24" ||
        selectedIndikator === "indikator_5" ||
        selectedIndikator === "indikator_4" ||
        selectedIndikator === "indikator_11" ||
        selectedIndikator === "indikator_10" ||
        selectedIndikator === "indikator_14" ||
        selectedIndikator === "indikator_19" ||
        selectedIndikator === "indikator_9" ||
        selectedIndikator === "indikator_8" ||
        selectedIndikator === "indikator_23" ||
        selectedIndikator === "indikator_23A" ||
        selectedIndikator === "indikator_12" ||
        selectedIndikator === "indikator_13" ||
        selectedIndikator === "indikator_15" ||
        selectedIndikator === "indikator_17" ||
        selectedIndikator === "indikator_18" ||
        selectedIndikator === "indikator_21" ||
        selectedIndikator === "indikator_22"
      ) {
        return (
          <div className="filter-condition" key={selectPeriode}>
            <InputDate
              label={"Dari"}
              placeholder={"Pilih Dari"}
              dateFormat={"YYYY-MM"}
              onChange={(e) => {
                setDate({
                  ...date,
                  year: moment(e).format("YYYY"),
                  dateFrom: moment(e).format("YYYY-MM"),
                });
                setPeriodDate({ ...periodDate, year: e, startDate: e });
              }}
              value={periodDate.month || periodDate.startDate}
            />
            <InputDate
              label={"Sampai"}
              placeholder={"Pilih Sampai"}
              dateFormat={"YYYY-MM"}
              isDisabled={!date.dateFrom}
              onChange={(e) => {
                if (date.dateFrom && e < date.dateFrom) {
                  toast.error(
                    "Bulan Sampai tidak boleh lebih kecil dari Bulan Dari"
                  );
                  return;
                }
                setDate({
                  ...date,
                  month: moment(e).format("MM"),
                  dateTo: moment(e).format("YYYY-MM"),
                });
                setPeriodDate({ ...periodDate, year: e, endDate: e });
              }}
              value={periodDate.month || periodDate.endDate}
            />
          </div>
        );
      } else if (
        selectedIndikator === "indikator_3" ||
        selectedIndikator === "indikator_16" ||
        selectedIndikator === "indikator_25" ||
        selectedIndikator === "indikator_6"
      ) {
        return (
          <div className="filter-condition" key={selectPeriode}>
            <InputDate
              label="Dari"
              placeholder={"Pilih Tahun"}
              dateFormat={"YYYY-MM"}
              onChange={(e) => {
                setDate({
                  ...date,
                  year: moment(e).format("YYYY"),
                  dateFrom: moment(e).format("YYYY-MM-DD"),
                });
                setPeriodDate({ ...periodDate, year: e, startDate: e });
              }}
              value={periodDate.startDate}
            />
            <InputDate
              label="Sampai"
              placeholder={"Pilih Bulan"}
              dateFormat={"YYYY-MM"}
              onChange={(e) => {
                setDate({
                  ...date,
                  month: moment(e).format("MM"),
                  dateTo: moment(e).format("YYYY-MM-DD"),
                });
                setPeriodDate({ ...periodDate, month: e, endDate: e });
              }}
              value={periodDate.endDate}
            />
          </div>
        );
      }
    } else if (selectPeriode === "Mingguan") {
      if (
        selectedIndikator === "indikator_3" ||
        selectedIndikator === "indikator_16" ||
        selectedIndikator === "indikator_25" ||
        selectedIndikator === "indikator_6"
      ) {
        const weeks = generateWeeks(date.year);
        return (
          <div key={selectPeriode}>
            <div className="filter-condition">
              <InputDate
                label="Dari"
                placeholder={"Pilih Tahun"}
                dateFormat={"YYYY"}
                onChange={(e) => {
                  setDate({
                    ...date,
                    year: moment(e).format("YYYY"),
                    dateFrom: moment(e).format("YYYY-MM-DD"),
                  });
                  setPeriodDate({ ...periodDate, year: e, startDate: e });
                }}
                value={periodDate.startDate}
              />
              <InputSelect
                label={"Minggu ke-"}
                placeholder={"Pilih Minggu ke-"}
                isDisabled={!periodDate.startDate}
                data={weeks.map((item) => ({
                  label: `${item.label} (${item.value})`,
                  value:
                    item.label?.split(" ")[1] < 10
                      ? `0${item.label?.split(" ")[1]}`
                      : item.label?.split(" ")[1],
                }))}
                onChange={(e) => {
                  const selectedValue = e ? e.value : "";
                  setDate({ ...date, w1: selectedValue });
                }}
                value={
                  date.w1
                    ? {
                      label: date.w1 || "",
                      value: date.w1,
                    }
                    : null
                }
              />
            </div>
            <div className="filter-condition">
              <InputDate
                label="Sampai"
                placeholder={"Pilih Tahun"}
                dateFormat={"YYYY"}
                onChange={(e) => {
                  setDate({
                    ...date,
                    year: moment(e).format("YYYY"),
                    dateTo: moment(e).format("YYYY-MM-DD"),
                  });
                  setPeriodDate({ ...periodDate, year: e, endDate: e });
                }}
                value={periodDate.endDate}
              />
              <InputSelect
                label={"Minggu ke-"}
                placeholder={"Pilih Minggu ke-"}
                isDisabled={!periodDate.endDate}
                data={weeks.map((item) => ({
                  label: `${item.label} (${item.value})`,
                  value:
                    item.label?.split(" ")[1] < 10
                      ? `0${item.label?.split(" ")[1]}`
                      : item.label?.split(" ")[1],
                }))}
                onChange={(e) => {
                  const selectedValue = e ? e.value : "";
                  setDate({ ...date, w2: selectedValue });
                }}
                value={
                  date.w2
                    ? {
                      label: date.w2 || "",
                      value: date.w2,
                    }
                    : null
                }
              />
            </div>
          </div>
        );
      } else {
        const weeks = generateWeeks(date.year);
        return (
          <div className="filter-condition" key={selectPeriode}>
            <InputDate
              placeholder={"Pilih Tahun"}
              dateFormat={"YYYY"}
              value={date.year}
              onChange={(e) => {
                setDate({ ...date, year: moment(e).format("YYYY") });
                setPeriodDate({ year: e });
              }}
            />
            <InputSelect
              placeholder={"Pilih Minggu"}
              isDisabled={!date.year}
              data={weeks.map((week) => ({
                label: `${week.label} ${week.value}`,
                value: week.value,
              }))}
              onChange={(e) => {
                setDate({ ...date, week: e.value });
                setPeriodDate({ week: e.value });
              }}
              value={
                date.week
                  ? {
                    label: date.week || "",
                    value: date.week,
                  }
                  : null
              }
            />
          </div>
        );
      }
    } else if (selectPeriode === "Harian") {
      return (
        <div className="filter-condition" key={selectPeriode}>
          <InputDate
            label={"Dari"}
            placeholder={"Pilih Tanggal"}
            dateFormat={"YYYY-MM-DD"}
            onChange={(e) => {
              setDate({
                ...date,
                year: moment(e).format("YYYY"),
                dateFrom: moment(e).format("YYYY-MM-DD"),
              });
              setPeriodDate({ ...periodDate, year: e, startDate: e });
            }}
            value={periodDate.year || periodDate.startDate}
          />
          <InputDate
            label={"Sampai"}
            placeholder={"Pilih Tanggal"}
            dateFormat={"YYYY-MM-DD"}
            onChange={(e) => {
              setDate({
                ...date,
                month: moment(e).format("MM"),
                dateTo: moment(e).format("YYYY-MM-DD"),
              });
              setPeriodDate({ ...periodDate, month: e, endDate: e });
            }}
            value={periodDate.month || periodDate.endDate}
          />
        </div>
      );
    } else {
      return null;
    }
  };

  const renderLevelFilter = () => {
    if (selectLevel === UserLevel.Province) {
      return (
        <div style={{ display: "flex", flexDirection: "row", gap: "1.2rem" }}>
          <div style={{ flex: "1" }}>
            <InputSelect
              placeholder={"Pilih Provinsi"}
              data={domicile.provincies}
              onChange={(e) => {
                const value = e ? e.value : null;
                setDomicileSelected({
                  ...domicileSelected,
                  provincies: value,
                  districts: null,
                  fasyankes: null,
                });
              }}
              value={
                domicileSelected.provincies
                  ? domicile.provincies.find(
                    (f) => f.value === domicileSelected.provincies
                  )
                  : domicileSelected.provincies
              }
              isDisabled={
                currentUser.level === UserLevel.National ? false : true
              }
            />
          </div>
        </div>
      );
    } else if (selectLevel === UserLevel.District) {
      return (
        <div style={{ display: "flex", flexDirection: "row", gap: "1.2rem" }}>
          <div style={{ flex: "1" }}>
            <InputSelect
              placeholder={"Pilih Provinsi"}
              data={domicile.provincies}
              onChange={(e) => {
                const value = e ? e.value : null;
                setDomicileSelected({
                  ...domicileSelected,
                  provincies: value,
                  districts: null,
                  fasyankes: null,
                });
              }}
              value={
                domicileSelected.provincies
                  ? domicile.provincies.find(
                    (f) => f.value === domicileSelected.provincies
                  )
                  : domicileSelected.provincies
              }
              isDisabled={
                currentUser.level === UserLevel.National ? false : true
              }
            />
          </div>
          <div style={{ flex: "1" }}>
            <InputSelect
              placeholder={"Pilih Kab/Kota"}
              data={domicile.districts}
              onChange={(e) => {
                const value = e ? e.value : null;
                setDomicileSelected({
                  ...domicileSelected,
                  districts: value,
                  fasyankes: null,
                });
              }}
              value={
                domicileSelected.districts
                  ? domicile.districts.find(
                    (f) => f.value === domicileSelected.districts
                  )
                  : domicileSelected.districts
              }
              isDisabled={
                currentUser.level === UserLevel.National ||
                  currentUser.level === UserLevel.Province ||
                  currentUser.level === UserLevel.SR
                  ? false
                  : true
              }
            />
          </div>
        </div>
      );
    } else if (selectLevel === UserLevel.Fasyankes) {
      return (
        <div style={{ display: "flex", flexDirection: "row", gap: "1.2rem" }}>
          <div style={{ flex: "1" }}>
            <InputSelect
              placeholder={"Pilih Provinsi"}
              data={domicile.provincies}
              onChange={(e) => {
                const value = e ? e.value : null;
                setDomicileSelected({
                  ...domicileSelected,
                  provincies: value,
                  districts: null,
                  fasyankes: null,
                });
              }}
              value={
                domicileSelected.provincies
                  ? domicile.provincies.find(
                    (f) => f.value === domicileSelected.provincies
                  )
                  : domicileSelected.provincies
              }
              isDisabled={
                currentUser?.level === UserLevel.National ? false : true
              }
            />
          </div>
          <div style={{ flex: "1" }}>
            <InputSelect
              placeholder={"Pilih Kab/Kota"}
              data={domicile.districts}
              onChange={(e) => {
                const value = e ? e.value : null;
                setDomicileSelected({
                  ...domicileSelected,
                  districts: value,
                  fasyankes: null,
                });
              }}
              value={
                domicileSelected.districts
                  ? domicile.districts.find(
                    (f) => f.value === domicileSelected.districts
                  )
                  : domicileSelected.districts
              }
              isDisabled={
                currentUser?.level === UserLevel.National ||
                  currentUser?.level === UserLevel.Province ||
                  currentUser.level === UserLevel.SR
                  ? false
                  : true
              }
            />
          </div>
          <div style={{ flex: "1" }}>
            <InputSelect
              placeholder={"Pilih Fasyankes"}
              data={domicile.fasyankes}
              onChange={(e) => {
                const value = e ? e.value : null;
                setDomicileSelected({ ...domicileSelected, fasyankes: value });
              }}
              value={
                domicileSelected.fasyankes
                  ? domicile.fasyankes.find(
                    (f) => f.value === domicileSelected.fasyankes
                  )
                  : domicileSelected.fasyankes
              }
              isDisabled={
                currentUser?.level === UserLevel.National ||
                  currentUser?.level === UserLevel.Province ||
                  currentUser?.level === UserLevel.District ||
                  currentUser.level === UserLevel.SR ||
                  currentUser.level === UserLevel.SSR
                  ? false
                  : true
              }
            />
          </div>
        </div>
      );
    } else if (selectLevel === UserLevel.BKKInduk) {
      return (
        <div style={{ display: "flex", flexDirection: "row", gap: "1.2rem" }}>
          <div style={{ flex: "1" }}>
            <InputSelect
              isClearable={false}
              placeholder={"Pilih Induk"}
              data={levelDataOptions.induks}
              onChange={(e) => {
                setSelectedInduk(e.value);
                setLevelIdSelected(e.value);
              }}
              value={
                levelDataOptions.induks?.find(
                  (item) => item.value === selectedInduk
                ) || ""
              }
              isDisabled={
                !(
                  currentUser?.level === UserLevel.National ||
                  currentUser?.level === UserLevel.Province ||
                  currentUser?.level === UserLevel.District
                )
              }
            />
          </div>
        </div>
      );
    } else if (selectLevel === UserLevel.BKKWilker) {
      return (
        <div style={{ display: "flex", flexDirection: "row", gap: "1.2rem" }}>
          <div style={{ flex: "1" }}>
            <InputSelect
              isClearable={false}
              placeholder={"Pilih Induk"}
              data={levelDataOptions.induks}
              onChange={(e) => {
                setSelectedInduk(e.value);
                setSelectedWilker("");
                setLevelIdSelected("");
              }}
              value={
                levelDataOptions.induks?.find(
                  (item) => item.value === selectedInduk
                ) || ""
              }
              isDisabled={
                !(
                  currentUser?.level === UserLevel.National ||
                  currentUser?.level === UserLevel.Province ||
                  currentUser?.level === UserLevel.District
                )
              }
            />
          </div>
          <div style={{ flex: "1" }}>
            <InputSelect
              isClearable={false}
              placeholder={"Pilih Wilker"}
              data={
                currentUser.level === UserLevel.BKKWilker
                  ? levelDataOptions.wilkers.filter(
                    (i) =>
                      i.value ===
                      `${currentUser.username}|${currentUser.first_name}`,
                  )
                  : levelDataOptions.wilkers
              }
              onChange={(e) => {
                setSelectedWilker(e.value);
                setLevelIdSelected(e.value);
              }}
              value={
                levelDataOptions.wilkers?.find(
                  (item) => item.value === selectedWilker
                ) || ""
              }
              isDisabled={
                !(
                  currentUser?.level === UserLevel.National ||
                  currentUser?.level === UserLevel.Province ||
                  currentUser?.level === UserLevel.District ||
                  currentUser?.level === UserLevel.BKKInduk
                )
              }
            />
          </div>
        </div>
      );
    } else {
      return null;
    }
  };

  const handleApplyFilter = async () => {
    setAppliedPeriod(selectPeriode);
    setAppliedLevel(selectLevel);
    setShowChart(true);
    setLoading(true);
    if (currentUser.level && selectLevel) {
      let dateSelected = "";
      let levelIdSelected = "";
      if (selectPeriode === "Tahunan") {
        if (
          selectedIndikator === "indikator_3" ||
          selectedIndikator === "indikator_16" ||
          selectedIndikator === "indikator_25" ||
          selectedIndikator === "indikator_6"
        ) {
          dateSelected = `${date.dateFrom}|${date.dateTo}`;
        } else {
          dateSelected = date.year;
        }
      } else if (selectPeriode === "Bulanan") {
        if (date.dateFrom && date.dateTo && date.dateTo < date.dateFrom) {
          toast.error(
            "Bulan Sampai tidak boleh lebih kecil dari Bulan Dari"
          );
          setLoading(false);
          return;
        }
        if (
          selectedIndikator === "indikator_1" ||
          selectedIndikator === "indikator_2" ||
          selectedIndikator === "indikator_30" ||
          selectedIndikator === "indikator_20" ||
          selectedIndikator === "indikator_7" ||
          selectedIndikator === "indikator_24" ||
          selectedIndikator === "indikator_5" ||
          selectedIndikator === "indikator_4" ||
          selectedIndikator === "indikator_11" ||
          selectedIndikator === "indikator_10" ||
          selectedIndikator === "indikator_14" ||
          selectedIndikator === "indikator_19" ||
          selectedIndikator === "indikator_9" ||
          selectedIndikator === "indikator_8" ||
          selectedIndikator === "indikator_23" ||
          selectedIndikator === "indikator_23A" ||
          selectedIndikator === "indikator_3" ||
          selectedIndikator === "indikator_12" ||
          selectedIndikator === "indikator_13" ||
          selectedIndikator === "indikator_15" ||
          selectedIndikator === "indikator_16" ||
          selectedIndikator === "indikator_17" ||
          selectedIndikator === "indikator_18" ||
          selectedIndikator === "indikator_21" ||
          selectedIndikator === "indikator_22" ||
          selectedIndikator === "indikator_25" ||
          selectedIndikator === "indikator_6"
        ) {
          dateSelected = `${date.dateFrom}|${date.dateTo}`;
        }
      } else if (selectPeriode === "Mingguan") {
        if (selectedIndikator === "indikator_20") {
          // kematian.js menentukan format tanggal dari panjang string, jadi kirim ISO
          dateSelected = weeklyRangeToIso(date.week).join("|");
        } else if (
          selectedIndikator === "indikator_11" ||
          selectedIndikator === "indikator_19"
        ) {
          dateSelected = `${date.week}`;
        } else if (
          selectedIndikator === "indikator_3" ||
          selectedIndikator === "indikator_16" ||
          selectedIndikator === "indikator_25" ||
          selectedIndikator === "indikator_6"
        ) {
          dateSelected = `${date.dateFrom};${date.w1}|${date.dateTo};${date.w2}`;
        } else {
          dateSelected = `${date.year}-${date.week}`;
        }
      } else if (selectPeriode === "Harian") {
        if (date.dateFrom && date.dateTo && date.dateTo < date.dateFrom) {
          toast.error(
            "Tanggal Sampai tidak boleh lebih kecil dari Tanggal Dari"
          );
          setLoading(false);
          return;
        }
        dateSelected = `${date.dateFrom}|${date.dateTo}`;
      }
      if (selectLevel === UserLevel.Fasyankes) {
        levelIdSelected = domicileSelected.fasyankes;
      } else if (selectLevel === UserLevel.BKKInduk) {
        levelIdSelected = selectedInduk;
      } else if (selectLevel === UserLevel.BKKWilker) {
        levelIdSelected = selectedWilker;
      } else if (selectLevel === UserLevel.District) {
        levelIdSelected = domicileSelected.districts;
      } else if (selectLevel === UserLevel.Province) {
        levelIdSelected = domicileSelected.provincies;
      } else if (selectLevel === UserLevel.National) {
        levelIdSelected = "1";
      }

      const levelIdValue = levelIdSelected?.includes("|")
        ? levelIdSelected?.split("|")[0]
        : levelIdSelected;

      setLevelIdSelected(
        levelIdSelected == "1"
          ? "INDONESIA"
          : levelIdSelected?.includes("|")
            ? levelIdSelected?.split("|")[1]
            : levelIdSelected
      );

      if (
        (selectedIndikator == "indikator_27" || dateSelected) &&
        selectedIndikator
      ) {
        let apiLevel = selectLevel.toLowerCase();
        if (selectLevel === UserLevel.BKKInduk) apiLevel = "bkk_induk";
        if (selectLevel === UserLevel.BKKWilker) apiLevel = "bkk_wilker";

        await getAnalysis(
          dateSelected,
          apiLevel,
          levelIdValue,
          selectedIndikator
        );
      }
      setDateString(dateSelected);
      if (selectLevel === "National") {
        setCurrentDomicile("Nasional");
      } else if (selectLevel === "Province" || selectLevel === UserLevel.SR) {
        setCurrentDomicile(domicileSelected.provincies?.split("|")[1] || "");
      } else if (selectLevel === "District" || selectLevel === UserLevel.SSR) {
        setCurrentDomicile(
          `${domicileSelected.provincies?.split("|")[1] || ""} - ${domicileSelected.districts?.split("|")[1] || ""
          }`
        );
      } else if (selectLevel === UserLevel.Fasyankes) {
        setCurrentDomicile(
          `${domicileSelected.provincies?.split("|")[1] || ""} - ${domicileSelected.districts?.split("|")[1] || ""
          } - ${domicileSelected.fasyankes?.split("|")[1] || ""}`
        );
      } else if (selectLevel === UserLevel.BKKInduk) {
        setCurrentDomicile(
          `${domicileSelected.provincies?.split("|")[1] || ""} - ${domicileSelected.districts?.split("|")[1] || ""
          } - ${selectedInduk?.split("|")[1] || ""}`
        );
      } else if (selectLevel === UserLevel.BKKWilker) {
        setCurrentDomicile(
          `${domicileSelected.provincies?.split("|")[1] || ""} - ${domicileSelected.districts?.split("|")[1] || ""
          } - ${selectedWilker?.split("|")[1] || ""}`
        );
      }
    }
    setLoading(false);
  };

  const getAllProvincies = async () => {
    try {
      const response = await WilayahService.getAll(Source.PROVINCE, {
        page: 1,
        limit: 999,
      });

      setDomicile((prevState) => ({
        ...prevState,
        provincies: response.province.map((province) => {
          return {
            label: province.name,
            value: `${province.id}|${province.name}`,
          };
        }),
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const getAllDistrictsByProvince = async (provinceId) => {
    try {
      const response = await WilayahService.getAll(Source.DISTRICT, {
        page: 1,
        limit: 9999,
        searchBy: `province_id`,
        searchValue: provinceId?.split("|")[0],
      });

      const data = response.district.map((item) => ({
        label: item.name,
        value: `${item.id}|${item.name}`,
      }));

      setDomicile((prevState) => ({
        ...prevState,
        districts: data,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const getAllFasyankesByDistrict = async (districtId) => {
    try {
      const response = await FasyankesService.getAll(Source.FASYANKES, {
        page: 1,
        limit: 9999,
        searchBy: `district_id`,
        searchValue: districtId?.split("|")[0],
        excludePkm: false,
      });

      const data = response.fasyankes.map((item) => ({
        label: item.name,
        value: `${item.id}|${item.name}`,
        fasyankes_type_id: item.fasyankes_type_id,
      }));

      setDomicile((prevState) => ({
        ...prevState,
        fasyankes: data,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const getAnalysis = async (date, level, level_id, indikator) => {
    try {
      let response = null;
      if (indikator === "indikator_1") {
        response = await AnalysisService.getReportCompleteness({
          date,
          dateStart: selectPeriode === "Bulanan" ? date?.split("|")[0] : null,
          dateEnd: selectPeriode === "Bulanan" ? date?.split("|")[1] : null,
          level,
          level_id,
        });
      } else if (indikator === "indikator_2") {
        response = await AnalysisService.getPositiveCase({
          date,
          dateStart: selectPeriode === "Bulanan" ? date?.split("|")[0] : null,
          dateEnd: selectPeriode === "Bulanan" ? date?.split("|")[1] : null,
          level,
          level_id,
        });
      } else if (indikator === "indikator_30") {
        response = await AnalysisService.getPositiveCaseByVillage({
          date,
          dateStart: selectPeriode === "Bulanan" ? date?.split("|")[0] : null,
          dateEnd: selectPeriode === "Bulanan" ? date?.split("|")[1] : null,
          level,
          level_id,
        });
      } else if (indikator === "indikator_3") {
        const finalDate = date?.split("|");
        response = await AnalysisService.getDeathTrends({
          level,
          level_id,
          period:
            selectPeriode === "Tahunan"
              ? "yearly"
              : selectPeriode === "Bulanan"
                ? "monthly"
                : selectPeriode === "Mingguan"
                  ? "weekly"
                  : "daily",
          dateStart:
            selectPeriode === "Tahunan"
              ? new Date(finalDate[0]).getFullYear().toString()
              : selectPeriode === "Bulanan"
                ? `${finalDate[0]?.split("-")[0]}-${finalDate[0]?.split("-")[1]}`
                : selectPeriode === "Mingguan"
                  ? `${finalDate[0]?.split("-")[0]}-${finalDate[0]?.split(";")[1]}`
                  : finalDate[0],
          dateEnd:
            selectPeriode === "Tahunan"
              ? new Date(finalDate[1]).getFullYear().toString()
              : selectPeriode === "Bulanan"
                ? `${finalDate[1]?.split("-")[0]}-${finalDate[1]?.split("-")[1]}`
                : selectPeriode === "Mingguan"
                  ? `${finalDate[1]?.split("-")[0]}-${finalDate[1]?.split(";")[1]}`
                  : finalDate[1],
        });
      } else if (indikator === "indikator_4") {
        response = await AnalysisService.getLaboratoryConfirmedSuspect({
          date,
          dateStart: selectPeriode === "Bulanan" ? date?.split("|")[0] : null,
          dateEnd: selectPeriode === "Bulanan" ? date?.split("|")[1] : null,
          level,
          level_id,
        });
      } else if (indikator === "indikator_5") {
        response = await AnalysisService.getABER({
          date,
          dateStart: selectPeriode === "Bulanan" ? date?.split("|")[0] : null,
          dateEnd: selectPeriode === "Bulanan" ? date?.split("|")[1] : null,
          level,
          level_id,
        });
      } else if (indikator === "indikator_6") {
        const finalDate = date?.split("|");

        response = await AnalysisService.getValidatedIndegenousCase({
          level,
          level_id,
          period:
            selectPeriode === "Tahunan"
              ? "yearly"
              : selectPeriode === "Bulanan"
                ? "monthly"
                : selectPeriode === "Mingguan"
                  ? "weekly"
                  : "daily",
          dateStart:
            selectPeriode === "Tahunan"
              ? new Date(finalDate[0]).getFullYear().toString()
              : selectPeriode === "Bulanan"
                ? `${finalDate[0]?.split("-")[0]}-${finalDate[0]?.split("-")[1]}`
                : selectPeriode === "Mingguan"
                  ? `${finalDate[0]?.split("-")[0]}-${finalDate[0]?.split(";")[1]}`
                  : finalDate[0],
          dateEnd:
            selectPeriode === "Tahunan"
              ? new Date(finalDate[1]).getFullYear().toString()
              : selectPeriode === "Bulanan"
                ? `${finalDate[1]?.split("-")[0]}-${finalDate[1]?.split("-")[1]}`
                : selectPeriode === "Mingguan"
                  ? `${finalDate[1]?.split("-")[0]}-${finalDate[1]?.split(";")[1]}`
                  : finalDate[1],
        });
      } else if (indikator === "indikator_7") {
        response = await AnalysisService.getInspection({
          date,
          dateStart: selectPeriode === "Bulanan" ? date?.split("|")[0] : null,
          dateEnd: selectPeriode === "Bulanan" ? date?.split("|")[1] : null,
          level,
          level_id,
        });
      } else if (indikator === "indikator_8") {
        response = await AnalysisService.getApiMoreOne({
          date,
          dateStart: selectPeriode === "Bulanan" ? date?.split("|")[0] : null,
          dateEnd: selectPeriode === "Bulanan" ? date?.split("|")[1] : null,
          level,
          level_id,
        });
      } else if (indikator === "indikator_9") {
        response = await AnalysisService.getApiLessOne({
          date,
          dateStart: selectPeriode === "Bulanan" ? date?.split("|")[0] : null,
          dateEnd: selectPeriode === "Bulanan" ? date?.split("|")[1] : null,
          level,
          level_id,
        });
      } else if (indikator === "indikator_11") {
        const finalDate = date?.split(
          selectPeriode === "Mingguan" ? " - " : "|"
        );
        response = await AnalysisService.getStandardMedication({
          dateStart:
            selectPeriode === "Bulanan"
              ? date?.split("|")[0]
              : selectPeriode === "Tahunan"
                ? date
                : finalDate[0],
          dateEnd:
            selectPeriode === "Bulanan"
              ? date?.split("|")[1]
              : selectPeriode === "Tahunan"
                ? date
                : finalDate[1],
          level,
          level_id,
        });
      } else if (indikator === "indikator_10") {
        response = await AnalysisService.getPositivityRate({
          level,
          level_id,
          period:
            selectPeriode === "Tahunan"
              ? "yearly"
              : selectPeriode === "Bulanan" && "monthly",
          year: selectPeriode === "Tahunan" ? date : null,
          dateStart:
            selectPeriode === "Bulanan" ? date?.split("|")[0] : null,
          dateEnd: selectPeriode === "Bulanan" ? date?.split("|")[1] : null,
          month: null,
        });
      } else if (indikator === "indikator_12") {
        response = await AnalysisService.getProporsiJenisPlasmodiun({
          dateStart: date?.split("|")[0],
          dateEnd: date?.split("|")[1],
          level,
          level_id,
        });
      } else if (indikator === "indikator_13") {
        response = await AnalysisService.getKasusIndigenous({
          dateStart: date?.split("|")[0],
          dateEnd: date?.split("|")[1],
          level,
          level_id,
        });
      } else if (indikator === "indikator_15") {
        response = await AnalysisService.getPosCasePE({
          dateStart: date?.split("|")[0],
          dateEnd: date?.split("|")[1],
          level,
          level_id,
        });
      } else if (indikator === "indikator_21") {
        response = await AnalysisService.getProportionPositiveCaseOperator({
          dateStart: selectPeriode === "Tahunan" ? date : date?.split("|")[0],
          dateEnd: selectPeriode === "Tahunan" ? date : date?.split("|")[1],
          level,
          level_id,
        });
      } else if (indikator === "indikator_22") {
        response = await AnalysisService.getProportionCaseClassification({
          dateStart: selectPeriode === "Tahunan" ? date : date?.split("|")[0],
          dateEnd: selectPeriode === "Tahunan" ? date : date?.split("|")[1],
          level,
          level_id,
        });
      } else if (indikator === "indikator_17") {
        response = await AnalysisService.getProportionDiscoveryActivity({
          dateStart: selectPeriode === "Tahunan" ? date : date?.split("|")[0],
          dateEnd: selectPeriode === "Tahunan" ? date : date?.split("|")[1],
          level,
          level_id,
        });
      } else if (indikator === "indikator_18") {
        response = await AnalysisService.getProportionPositiveCaseOwnership({
          dateStart: selectPeriode === "Tahunan" ? date : date?.split("|")[0],
          dateEnd: selectPeriode === "Tahunan" ? date : date?.split("|")[1],
          level,
          level_id,
        });
      } else if (indikator === "indikator_19") {
        const finalDate = date?.split(
          selectPeriode === "Mingguan" ? " - " : "|"
        );
        response = await AnalysisService.getIndicatorLogisticOffStock({
          dateStart:
            selectPeriode === "Bulanan"
              ? date?.split("|")[0]
              : selectPeriode === "Tahunan"
                ? date
                : finalDate[0],
          dateEnd:
            selectPeriode === "Bulanan"
              ? date?.split("|")[1]
              : selectPeriode === "Tahunan"
                ? date
                : finalDate[1],
          level,
          level_id,
        });
      } else if (indikator === "indikator_20") {
        const finalDate = date?.split("|");
        response = await AnalysisService.getDeaths({
          dateStart:
            selectPeriode === "Bulanan"
              ? date?.split("|")[0]
              : selectPeriode === "Tahunan"
                ? date
                : finalDate[0],
          dateEnd:
            selectPeriode === "Bulanan"
              ? date?.split("|")[1]
              : selectPeriode === "Tahunan"
                ? date
                : finalDate[1],
          level,
          level_id,
        });
      } else if (indikator === "indikator_14") {
        response = await AnalysisService.getReportLogisticCompleteness({
          date,
          dateStart: selectPeriode === "Bulanan" ? date?.split("|")[0] : null,
          dateEnd: selectPeriode === "Bulanan" ? date?.split("|")[1] : null,
          level,
          level_id,
        });
      } else if (indikator === "indikator_23") {
        response = await AnalysisService.getCaderPerformance({
          date,
          dateStart: selectPeriode === "Bulanan" ? date?.split("|")[0] : null,
          dateEnd: selectPeriode === "Bulanan" ? date?.split("|")[1] : null,
          level,
          level_id,
          type: "kunjungan",
        });
      } else if (indikator === "indikator_23A") {
        response = await AnalysisService.getCaderPerformance({
          date,
          dateStart: selectPeriode === "Bulanan" ? date?.split("|")[0] : null,
          dateEnd: selectPeriode === "Bulanan" ? date?.split("|")[1] : null,
          level,
          level_id,
          type: "pemeriksaan",
        });
      } else if (indikator === "indikator_24") {
        response = await AnalysisService.getAnnualParasiteInsiden({
          date,
          dateStart: selectPeriode === "Bulanan" ? date?.split("|")[0] : null,
          dateEnd: selectPeriode === "Bulanan" ? date?.split("|")[1] : null,
          level,
          level_id,
        });
      } else if (selectedIndikator === "indikator_16") {
        const finalDate = date?.split("|");
        response = await AnalysisService.getSKDMalariaTrends({
          level,
          level_id,
          period:
            selectPeriode === "Tahunan"
              ? "yearly"
              : selectPeriode === "Bulanan"
                ? "monthly"
                : selectPeriode === "Mingguan"
                  ? "weekly"
                  : "daily",
          dateStart:
            selectPeriode === "Tahunan"
              ? new Date(finalDate[0]).getFullYear().toString()
              : selectPeriode === "Bulanan"
                ? `${finalDate[0]?.split("-")[0]}-${finalDate[0]?.split("-")[1]}`
                : selectPeriode === "Mingguan"
                  ? `${finalDate[0]?.split("-")[0]}-${finalDate[0]?.split(";")[1]}`
                  : finalDate[0],
          dateEnd:
            selectPeriode === "Tahunan"
              ? new Date(finalDate[1]).getFullYear().toString()
              : selectPeriode === "Bulanan"
                ? `${finalDate[1]?.split("-")[0]}-${finalDate[1]?.split("-")[1]}`
                : selectPeriode === "Mingguan"
                  ? `${finalDate[1]?.split("-")[0]}-${finalDate[1]?.split(";")[1]}`
                  : finalDate[1],
        });
      } else if (selectedIndikator === "indikator_25") {
        const finalDate = date?.split("|");
        response = await AnalysisService.getKetepatanPE({
          level,
          level_id,
          period:
            selectPeriode === "Tahunan"
              ? "yearly"
              : selectPeriode === "Bulanan"
                ? "monthly"
                : selectPeriode === "Mingguan"
                  ? "weekly"
                  : "daily",
          dateStart:
            selectPeriode === "Tahunan"
              ? new Date(finalDate[0]).getFullYear().toString()
              : selectPeriode === "Bulanan"
                ? `${finalDate[0]?.split("-")[0]}-${finalDate[0]?.split("-")[1]}`
                : selectPeriode === "Mingguan"
                  ? `${finalDate[0]?.split("-")[0]}-${finalDate[0]?.split(";")[1]}`
                  : finalDate[0],
          dateEnd:
            selectPeriode === "Tahunan"
              ? new Date(finalDate[1]).getFullYear().toString()
              : selectPeriode === "Bulanan"
                ? `${finalDate[1]?.split("-")[0]}-${finalDate[1]?.split("-")[1]}`
                : selectPeriode === "Mingguan"
                  ? `${finalDate[1]?.split("-")[0]}-${finalDate[1]?.split(";")[1]}`
                  : finalDate[1],
        });
      } else if (selectedIndikator === "indikator_26") {
        response = await AnalysisService.getPetaEndemis({
          year: new Date(date).getFullYear(),
          level_id,
          level,
        });
      } else if (selectedIndikator === "indikator_28") {
        response = await AnalysisService.getPetaFokus({
          year: new Date(date).getFullYear(),
          level_id,
          level,
        });
      } else if (selectedIndikator === "indikator_29") {
        response = await AnalysisService.getPetaReseptifitas({
          year: new Date(date).getFullYear(),
          level_id,
          level,
        });
      } else if (selectedIndikator === "indikator_27") {
        response = await AnalysisService.getProporsiJenisMMP({
          level,
          level_id,
        });
      } else if (indikator === "indikator_31") {
        response = await AnalysisService.getTrenPemantauanJentikBulanan({
          date,
          level,
          level_id,
        });
      } else if (indikator === "indikator_32") {
        const [dateStart, dateEnd] = (date || "").split("|");
        response = await AnalysisService.getTrenPemantauanJentikHarian({
          dateStart,
          dateEnd,
          level,
          level_id,
        });
      }

      if (response) {
        if (
          indikator === "indikator_17" ||
          indikator === "indikator_18" ||
          indikator === "indikator_21" ||
          indikator === "indikator_22" ||
          indikator === "indikator_23" ||
          indikator === "indikator_23A" ||
          indikator === "indikator_27"
        ) {
          setChartData(response);
        } else if (
          indikator === "indikator_5" ||
          indikator === "indikator_24" ||
          indikator === "indikator_10"
        ) {
          setChartData(response.result);
        } else if (indikator === "indikator_2" && level === "fasyankes") {
          const selectedFaskes = domicile.fasyankes.find(
            (f) => f.value === domicileSelected.fasyankes
          );

          const isNonPkm =
            selectedFaskes?.fasyankes_type_id !== "jnsfas-01" &&
            selectedFaskes?.fasyankes_type_id !== "jnsfas-02";

          if (isNonPkm) {
            setChartData(response.data);
            setTotalData(response.total);
            return;
          }

          const newData = [];
          const faskes = response?.data.filter(
            (o) => o.id === domicileSelected.fasyankes.split("|")[0]
          );
          const sameFaskes = response.data.filter(
            (o) =>
              faskes.some((p) => p.id !== o.id) &&
              o.pop_fasyankes_id === domicileSelected.fasyankes.split("|")[0]
          );

          // const diffProvince = response?.data
          //   ?.filter(
          //     (o) =>
          //       ![...faskes, ...sameFaskes].some((p) => p.id === o.id) &&
          //       o.pop_province_id !== domicileSelected.provincies.split("|")[0]
          //   )
          //   .reduce((acc, curr) => acc + Number(curr.positive_case), 0);
          // newData.push({
          //   id: "diffProvince",
          //   name: "Luar Wilayah Provinsi",
          //   positive_case: diffProvince,
          // });

          // const diffDistrict = response?.data
          //   ?.filter(
          //     (o) =>
          //       ![...faskes, ...sameFaskes].some((p) => p.id === o.id) &&
          //       o.pop_province_id ===
          //         domicileSelected.provincies.split("|")[0] &&
          //       o.pop_district_id !== domicileSelected.districts.split("|")[0]
          //   )
          //   .reduce((acc, curr) => acc + Number(curr.positive_case), 0);
          // newData.push({
          //   id: "diffDistrict",
          //   name: "Luar Wilayah Kabupaten",
          //   positive_case: diffDistrict,
          // });

          const diffFasyankes = response?.data
            ?.filter(
              (o) =>
                ![...faskes, ...sameFaskes].some((p) => p.id === o.id) &&
                // o.pop_province_id ===
                //   domicileSelected.provincies.split("|")[0] &&
                // o.pop_district_id ===
                //   domicileSelected.districts.split("|")[0] &&
                o.pop_fasyankes_id !== domicileSelected.fasyankes.split("|")[0]
            )
            .reduce((acc, curr) => acc + Number(curr.positive_case), 0);
          newData.push({
            id: "diffFasyankes",
            name: `Luar Wilayah ${domicileSelected.fasyankes.split("|")[1]}`,
            positive_case: diffFasyankes,
          });

          const sortedSameFaskes = sameFaskes.sort(
            (a, b) => b.positive_case - a.positive_case
          );

          setChartData([...sortedSameFaskes, ...newData, ...faskes]);
          setTotalData(response.total);
        } else if (indikator === "indikator_2" && level === "district") {
          // const newData = [];
          // const district = response?.data.filter(
          //   (o) =>
          //     o.district_pencatat === domicileSelected.districts.split("|")[0]
          // );

          // const totalDistrict = response?.data.filter(
          //   (o) => o.id === domicileSelected.districts.split("|")[0]
          // );

          // const sameDistrict = response?.data.filter(
          //   (o) =>
          //     district.some((p) => p.id !== o.id) &&
          //     o.district_pencatat === domicileSelected.districts.split("|")[0]
          // );

          // const sameDistrictMerged = Object.values(
          //   sameDistrict.reduce((acc, item) => {
          //     const fasyankesId = item.faskes_pencatat;

          //     if (!acc[fasyankesId]) {
          //       acc[fasyankesId] = {
          //         id: fasyankesId,
          //         name: item.faskes_pencatat_name || "Unknown",
          //         positive_case: 0,
          //       };
          //     }

          //     // Handle null, undefined, NaN values
          //     const positiveCase = Number(item.positive_case) || 0;
          //     acc[fasyankesId].positive_case += positiveCase;

          //     return acc;
          //   }, {})
          // );

          // const diffProvince = response?.data
          //   ?.filter(
          //     (o) =>
          //       ![...district, ...sameDistrict].some((p) => p.id === o.id) &&
          //       o.province_pencatat !==
          //         domicileSelected.provincies.split("|")[0] &&
          //       o.province_pencatat !== undefined
          //   )
          //   .reduce((acc, curr) => acc + Number(curr.positive_case), 0);
          // newData.push({
          //   id: "diffProvince",
          //   name: "Luar Wilayah Provinsi",
          //   positive_case: diffProvince,
          // });

          // const diffDistrict = response?.data
          //   ?.filter(
          //     (o) =>
          //       ![...district, ...sameDistrict].some((p) => p.id === o.id) &&
          //       o.province_pencatat ===
          //         domicileSelected.provincies.split("|")[0] &&
          //       o.district_pencatat !== domicileSelected.districts.split("|")[0]
          //   )
          //   .reduce((acc, curr) => acc + Number(curr.positive_case), 0);
          // newData.push({
          //   id: "diffDistrict",
          //   name: "Luar Wilayah Kabupaten",
          //   positive_case: diffDistrict,
          // });

          // const sortedSameDistrict = sameDistrictMerged.sort(
          //   (a, b) => b.positive_case - a.positive_case
          // );

          setChartData(response.data);
          setTotalData(response.total);
        } else if (indikator === "indikator_2" && level === "province") {
          // const newData = [];
          // const province = response?.data.filter(
          //   (o) =>
          //     o.province_pencatat === domicileSelected.provincies.split("|")[0]
          // );

          // const totalProvince = response?.data.filter(
          //   (o) => o.id === domicileSelected.provincies.split("|")[0]
          // );

          // const sameProvince = response?.data.filter(
          //   (o) =>
          //     province.some((p) => p.id !== o.id) &&
          //     o.province_pencatat === domicileSelected.provincies.split("|")[0]
          // );

          // const sameProvinceMerged = Object.values(
          //   sameProvince.reduce((acc, item) => {
          //     if (!acc[item.district_pencatat]) {
          //       acc[item.district_pencatat] = {
          //         id: item.district_pencatat,
          //         name: item.district_pencatat_name,
          //         positive_case: 0,
          //       };
          //     }

          //     // Handle null, undefined, NaN values
          //     const positiveCase = Number(item.positive_case) || 0;
          //     acc[item.district_pencatat].positive_case += positiveCase;

          //     return acc;
          //   }, {})
          // );

          // const diffProvince = response?.data
          //   ?.filter(
          //     (o) =>
          //       ![...province, ...sameProvince].some((p) => p.id === o.id) &&
          //       o.province_pencatat !==
          //         domicileSelected.provincies.split("|")[0] &&
          //       o.province_pencatat !== undefined
          //   )
          //   .reduce((acc, curr) => acc + Number(curr.positive_case), 0);
          // newData.push({
          //   id: "diffProvince",
          //   name: "Luar Wilayah Provinsi",
          //   positive_case: diffProvince,
          // });

          // const sortedSameProvince = sameProvinceMerged.sort(
          //   (a, b) => b.positive_case - a.positive_case
          // );

          setChartData(response.data);
          setTotalData(response.total);
        } else if (indikator === "indikator_2" && level === "national") {
          // const newData = [];
          // const national = response?.data.filter((o) => o.id !== "1");

          // const totalNational = response?.data.filter((o) => o.id === "1");

          // const nationalMerged = Object.values(
          //   national.reduce((acc, item) => {
          //     if (!acc[item.province_pencatat]) {
          //       acc[item.province_pencatat] = {
          //         id: item.province_pencatat,
          //         name: item.province_pencatat_name,
          //         positive_case: 0,
          //       };
          //     }

          //     // Handle null, undefined, NaN values
          //     const positiveCase = Number(item.positive_case) || 0;
          //     acc[item.province_pencatat].positive_case += positiveCase;

          //     return acc;
          //   }, {})
          // );

          // const sortedNational = nationalMerged.sort(
          //   (a, b) => b.positive_case - a.positive_case
          // );

          setChartData(response.data);
          setTotalData(response.total);
        } else if (indikator === "indikator_30") {
          setChartData(response.data);
          setTotalData(response.total);
        } else {
          setChartData(response.data);
          setTotalData(response.total);
        }
      }
    } catch (error) {
      if (error.canceled) return;

      toast.error(`Gagal: ${error.response?.data?.message || error.message}`, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
        theme: "colored",
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchBKKInduk = async () => {
    try {
      const response = await BKKService.getAll({
        page: 1,
        limit: 9999,
        province_id: domicileSelected.provincies?.split("|")[0] || (currentUser?.level === UserLevel.Province ? currentUser.province_id : ""),
        district_id: domicileSelected.districts?.split("|")[0] || (currentUser?.level === UserLevel.District ? currentUser.district_id : ""),
      });

      const bkkList = response.bkk || [];
      const induks = bkkList.filter((item) => !item.induk_id);

      setLevelDataOptions((prevState) => ({
        ...prevState,
        induks: induks.map((item) => ({
          label: item.name,
          value: `${item.id}|${item.name}`,
        })),
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const fetchBKKWilker = async (indukId) => {
    try {
      const params = {
        page: 1,
        limit: 9999,
        province_id: domicileSelected.provincies?.split("|")[0] || (currentUser?.level === UserLevel.Province ? currentUser.province_id : ""),
        district_id: domicileSelected.districts?.split("|")[0] || (currentUser?.level === UserLevel.District ? currentUser.district_id : ""),
      };

      const response = await BKKService.getAll(params);
      const bkkList = response.bkk || [];

      let wilkers = bkkList.filter((item) => item.induk_id);
      if (indukId) {
        wilkers = wilkers.filter((item) => item.induk_id === indukId);
      }

      setLevelDataOptions((prevState) => ({
        ...prevState,
        wilkers: wilkers.map((item) => ({
          label: item.name,
          value: `${item.id}|${item.name}`,
        })),
      }));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllProvincies();
  }, []);

  useEffect(() => {
    if (domicileSelected.provincies) {
      getAllDistrictsByProvince(domicileSelected.provincies);
    }
  }, [domicileSelected.provincies]);

  useEffect(() => {
    if (domicileSelected.districts) {
      getAllFasyankesByDistrict(domicileSelected.districts);
    }
  }, [domicileSelected.districts]);

  useEffect(() => {
    switch (currentUser.level) {
      case UserLevel.Fasyankes:
        setLevelData([{ label: "Fasyankes", value: UserLevel.Fasyankes }]);
        break;
      case UserLevel.District:
      case UserLevel.SSR:
        setLevelData([
          {
            label:
              currentUser.level === UserLevel.District
                ? "Kabupaten"
                : currentUser.level,
            value: UserLevel.District,
          },
          { label: "Fasyankes", value: UserLevel.Fasyankes },
          { label: "BKK Induk", value: UserLevel.BKKInduk },
          { label: "BKK Wilker", value: UserLevel.BKKWilker },
        ]);
        break;
      case UserLevel.Province:
      case UserLevel.SR:
        setLevelData([
          {
            label:
              currentUser.level === UserLevel.Province
                ? "Provinsi"
                : currentUser.level,
            value: UserLevel.Province,
          },
          { label: "Kabupaten", value: UserLevel.District },
          { label: "Fasyankes", value: UserLevel.Fasyankes },
          { label: "BKK Induk", value: UserLevel.BKKInduk },
          { label: "BKK Wilker", value: UserLevel.BKKWilker },
        ]);
        break;
      case UserLevel.BKKInduk:
        setLevelData([
          { label: "BKK Induk", value: UserLevel.BKKInduk },
          { label: "BKK Wilker", value: UserLevel.BKKWilker },
        ]);
        break;
      case UserLevel.BKKWilker:
        setLevelData([
          { label: "BKK Wilker", value: UserLevel.BKKWilker },
        ]);
        break;
      default:
        setLevelData([
          { label: "Nasional", value: UserLevel.National },
          { label: "Provinsi", value: UserLevel.Province },
          { label: "Kabupaten", value: UserLevel.District },
          { label: "Fasyankes", value: UserLevel.Fasyankes },
          { label: "BKK Induk", value: UserLevel.BKKInduk },
          { label: "BKK Wilker", value: UserLevel.BKKWilker },
        ]);
        break;
    }

    const initBKKData = async () => {
      if (currentUser.level === UserLevel.BKKWilker) {
        setSelectedLevel(UserLevel.BKKWilker);
        setLevelIdSelected(`${currentUser.username}|${currentUser.first_name}`);
        try {
          const getBkk = await BKKService.getIndukByWilker(currentUser.username);
          if (getBkk) {
            setLevelDataOptions((prevState) => ({
              ...prevState,
              induks: [{ label: getBkk.induk_name, value: `${getBkk.induk_id}|${getBkk.induk_name}` }],
            }));
            setSelectedInduk(`${getBkk.induk_id}|${getBkk.induk_name}`);
          }
        } catch (e) {
          console.error(e);
        }
        setSelectedWilker(`${currentUser.username}|${currentUser.first_name}`);
      } else if (currentUser.level === UserLevel.BKKInduk) {
        setSelectedLevel(UserLevel.BKKInduk);
        setLevelIdSelected(`${currentUser.username}|${currentUser.first_name}`);
        setLevelDataOptions((prevState) => ({
          ...prevState,
          induks: [{ label: currentUser.first_name, value: `${currentUser.username}|${currentUser.first_name}` }],
        }));
        setSelectedInduk(`${currentUser.username}|${currentUser.first_name}`);
      }
    };
    initBKKData();
  }, []);

  useEffect(() => {
    if (selectLevel === UserLevel.BKKInduk || selectLevel === UserLevel.BKKWilker) {
      if (currentUser.level !== UserLevel.BKKWilker && currentUser.level !== UserLevel.BKKInduk) {
        fetchBKKInduk();
      }
    }
    if (
      selectLevel === UserLevel.BKKWilker &&
      currentUser.level !== UserLevel.BKKWilker
    ) {
      fetchBKKWilker(
        selectedInduk ? selectedInduk.split("|")[0] : selectedInduk
      );
    }
  }, [selectLevel, selectedInduk, domicileSelected.provincies, domicileSelected.districts]);

  return (
    <>
      <div className="filter">
        <div className="filter-header">
          <p>FILTER</p>
          <button
            className="btn_toggle_filter"
            onClick={() => setShowFilter(!showFilter)}
          >
            {showFilter ? <ArrowUp size={18} /> : <ArrowDown size={18} />}
          </button>
        </div>
        {showFilter && (
          <div className="filter-body">
            <div className="filter-item">
              <div className="filter-label">
                <p>Indikator</p>
              </div>
              <div className="filter-field">
                <InputSelect
                  placeholder={"Pilih Indikator"}
                  data={indikatorOptions}
                  onChange={(e) => {
                    const selectedValue = e ? e.value : "";
                    setSelectedIndikator(selectedValue);
                    setShowChart(false);
                    if (selectedValue === "indikator_31") {
                      setSelectPeriode("Tahunan");
                    } else if (selectedValue === "indikator_32") {
                      setSelectPeriode("Harian");
                    }
                  }}
                />
              </div>
            </div>
            {selectedIndikator !== "indikator_27" && (
              <div className="filter-item">
                <div className="filter-label">
                  <p>Periode Laporan</p>
                </div>
                <div className="filter-field">
                  <InputRadio
                    options={
                      selectedIndikator === "indikator_1" ||
                        selectedIndikator === "indikator_2" ||
                        selectedIndikator === "indikator_30" ||
                        selectedIndikator === "indikator_4" ||
                        selectedIndikator === "indikator_5" ||
                        selectedIndikator === "indikator_7" ||
                        selectedIndikator === "indikator_8" ||
                        selectedIndikator === "indikator_9" ||
                        selectedIndikator === "indikator_10" ||
                        selectedIndikator === "indikator_14" ||
                        selectedIndikator === "indikator_17" ||
                        selectedIndikator === "indikator_18" ||
                        selectedIndikator === "indikator_19" ||
                        selectedIndikator === "indikator_21" ||
                        selectedIndikator === "indikator_22" ||
                        selectedIndikator === "indikator_23" ||
                        selectedIndikator === "indikator_23A" ||
                        selectedIndikator === "indikator_24"
                        ? [
                          { label: "Tahunan", value: "Tahunan" },
                          { label: "Bulanan", value: "Bulanan" },
                        ]
                        : selectedIndikator === "indikator_3" ||
                          selectedIndikator === "indikator_6" ||
                          selectedIndikator === "indikator_11" ||
                          selectedIndikator === "indikator_16" ||
                          selectedIndikator === "indikator_20" ||
                          selectedIndikator === "indikator_25"
                          ? [
                            { label: "Tahunan", value: "Tahunan" },
                            { label: "Bulanan", value: "Bulanan" },
                            { label: "Mingguan", value: "Mingguan" },
                            { label: "Harian", value: "Harian" },
                          ]
                          : selectedIndikator === "indikator_12" ||
                            selectedIndikator === "indikator_13" ||
                            selectedIndikator === "indikator_15"
                            ? [{ label: "Bulanan", value: "Bulanan" }]
                            : selectedIndikator === "indikator_26" ||
                              selectedIndikator === "indikator_28" ||
                              selectedIndikator === "indikator_29"
                              ? [{ label: "Tahunan", value: "Tahunan" }]
                              : selectedIndikator === "indikator_31"
                                ? [{ label: "Tahunan", value: "Tahunan" }]
                                : selectedIndikator === "indikator_32"
                                  ? [{ label: "Harian", value: "Harian" }]
                                  : []
                    }
                    onChange={(e) => {
                      setSelectPeriode(e.target.value);
                      setDate(initialDate);
                      setPeriodDate(initialPeriodDate);
                    }}
                    selectedOption={selectPeriode}
                  />
                  <div className="advanced-filter">{renderPeriodeFilter()}</div>
                </div>
              </div>
            )}
            <div className="filter-item">
              <div className="filter-label">
                <p>Level</p>
              </div>
              <div className="filter-field">
                <InputRadio
                  options={
                    (() => {
                      const bkkSupported = ["indikator_1", "indikator_2", "indikator_4", "indikator_7", "indikator_8", "indikator_9", "indikator_10", "indikator_11", "indikator_20"];
                      let filteredData = levelData;

                      if (selectedIndikator === "indikator_26") {
                        filteredData = levelData.filter((r) => r.value === UserLevel.National || r.value === UserLevel.Province);
                      } else if (selectedIndikator === "indikator_28" || selectedIndikator === "indikator_29") {
                        filteredData = levelData.filter((r) => r.value !== UserLevel.National);
                      }

                      if (!bkkSupported.includes(selectedIndikator)) {
                        filteredData = filteredData.filter((r) => r.value !== UserLevel.BKKInduk && r.value !== UserLevel.BKKWilker);
                      }

                      return filteredData;
                    })()
                  }
                  onChange={(e) => {
                    setSelectedLevel(e.target.value);
                    setDomicileSelected(initialDomicileSelected);
                    setPeriodDate(initialPeriodDate);
                  }}
                  selectedOption={selectLevel}
                />
                <div className="advanced-filter">{renderLevelFilter()}</div>
              </div>
            </div>
            <div className="filter-action">
              <Button
                variant={"primary"}
                size={"normal"}
                onClick={() => handleApplyFilter()}
                isDisabled={
                  isLoading ||
                  (selectedIndikator !== "indikator_27" &&
                    !date.year &&
                    !date.week &&
                    !date.month &&
                    !date.dateFrom &&
                    !date.dateTo &&
                    !date.w1 &&
                    !date.w2)
                }
              >
                Terapkan
              </Button>
            </div>
          </div>
        )}
      </div>
      {isLoading && (
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "center",
            marginTop: "5rem",
          }}
        >
          <HashLoader size={100} color="#18b3ab" />
        </div>
      )}
      {showChart && !isLoading && (
        <div className="chart-container">
          <div className="chart-header">
            {
              indicatorAnalysisOptions.find(
                (r) => r.value === selectedIndikator
              ).label
            }
            <br />
            {selectedIndikator === "indikator_30" &&
              "Sumber data: Regmal-1 berdasarkan alamat domisili, Exclude FUP."}
          </div>
          <div className="chart-body">
            <div className="data-information">
              <p>
                <span className="title-label">Level:</span>
                {currentDomicile}
              </p>
              <p>
                <span className="title-label">Periode Laporan:</span>{" "}
                {dateString.includes(";")
                  ? `${dateString
                    ?.split("|")[0]
                    ?.split(";")[0]
                    ?.substring(0, 4)}
                      Minggu ke-${dateString?.split("|")[0]?.split(";")[1]
                  } Sampai
                      ${dateString
                    ?.split("|")[1]
                    ?.split(";")[0]
                    ?.substring(0, 4)} 
                      Minggu ke-${dateString?.split("|")[1]?.split(";")[1]}`
                  : dateString.includes("|")
                    ? `${dateString?.split("|")[0]} - ${dateString?.split("|")[1]
                    }`
                    : dateString.includes("-")
                      ? `${dateString?.split("-")[0]} - ${monthConverter(
                        dateString?.split("-")[1]
                      )}`
                      : dateString}
              </p>
            </div>
            {showChart && (
              <>
                {selectedIndikator === "indikator_31" ||
                selectedIndikator === "indikator_32" ? (
                  <>
                    <JentikTrendChart
                      data={chartData}
                      indicator={selectedIndikator}
                      levelIdSelected={levelIdSelected}
                    />
                    <JentikTrendTable
                      data={chartData}
                      indicator={selectedIndikator}
                    />
                  </>
                ) : selectedIndikator === "indikator_1" ||
                  selectedIndikator === "indikator_2" ||
                  selectedIndikator === "indikator_30" ||
                  selectedIndikator === "indikator_4" ||
                  selectedIndikator === "indikator_5" ||
                  selectedIndikator === "indikator_6" ||
                  selectedIndikator === "indikator_7" ||
                  selectedIndikator === "indikator_8" ||
                  selectedIndikator === "indikator_9" ||
                  selectedIndikator === "indikator_10" ||
                  selectedIndikator === "indikator_11" ||
                  selectedIndikator === "indikator_13" ||
                  selectedIndikator === "indikator_14" ||
                  selectedIndikator === "indikator_15" ||
                  selectedIndikator === "indikator_19" ||
                  selectedIndikator === "indikator_24" ||
                  selectedIndikator === "indikator_25" ? (
                  <Chart
                    data={chartData}
                    type="column2d"
                    indicator={selectedIndikator}
                    period={appliedPeriod}
                    level={appliedLevel}
                    levelIdSelected={levelIdSelected}
                  />
                ) : selectedIndikator === "indikator_20" ? (
                  <Chart
                    data={chartData}
                    type="stackedcolumn2d"
                    indicator={selectedIndikator}
                    period={appliedPeriod}
                    level={appliedLevel}
                    levelIdSelected={levelIdSelected}
                  />
                ) : selectedIndikator === "indikator_13" ? (
                  <Chart
                    data={chartData}
                    type="line"
                    indicator={selectedIndikator}
                    period={appliedPeriod}
                    level={appliedLevel}
                    levelIdSelected={levelIdSelected}
                  />
                ) : selectedIndikator === "indikator_3" ||
                  selectedIndikator === "indikator_16" ? (
                  <Chart
                    data={chartData}
                    type="mscombi2d"
                    indicator={selectedIndikator}
                    period={appliedPeriod}
                    level={appliedLevel}
                    levelIdSelected={levelIdSelected}
                  />
                ) : (
                  (selectedIndikator === "indikator_12" ||
                    selectedIndikator === "indikator_17" ||
                    selectedIndikator === "indikator_18" ||
                    selectedIndikator === "indikator_21" ||
                    selectedIndikator === "indikator_22" ||
                    selectedIndikator === "indikator_23" ||
                    selectedIndikator === "indikator_23A" ||
                    selectedIndikator === "indikator_27") && (
                    <Chart
                      totalData={totalData}
                      data={chartData}
                      type="pie2d"
                      indicator={selectedIndikator}
                      period={appliedPeriod}
                      level={appliedLevel}
                      levelIdSelected={levelIdSelected}
                    />
                  )
                )}
                {(selectedIndikator === "indikator_26" ||
                  selectedIndikator === "indikator_28" ||
                  selectedIndikator === "indikator_29") && (
                    <div className="map">
                      <MyMap
                        geoJson={chartData}
                        indicator={selectedIndikator}
                      />
                    </div>
                  )}
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default FilterDataComponent;
